import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    marginLeft: '0.5rem',
    cursor: 'pointer'
  },

  disabled: {
    cursor: 'default'
  },

  icon: {
    transform: 'rotate(90deg)'
  }
}))

export default useStyles
